import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

export default class extends Component {
    render() {
        let { bsSize = 'xsmall', style, text, onClick, onClose } = this.props;

        return (
            <Button className="ui-tag-item" style={style} bsSize={bsSize} onClick={onClick}>
                {text}
                <a onClick={onClose} className="icon icon-close"></a>
            </Button>
        );
    }
}


// WEBPACK FOOTER //
// ./src/ui/tag/item.js